/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateBatchRequest {
    getFixupPrototypeFunction() { return TemplateBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateBatchRequest>): TemplateBatchRequest {
        let obj = Object.assign(new TemplateBatchRequest(), model);
        TemplateBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateBatchRequest>): TemplateBatchRequest {
        if (!model) return null;
        return TemplateBatchRequest.newInstance(<TemplateBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateBatchRequest) {
        if (!obj) return;

        models.TemplateBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateBatchRequest): boolean {
        Object.setPrototypeOf(obj, TemplateBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Template IDs to fetch full details for
     */
    ids: Array<string>;

}
